import React from 'react';
import {
  caseStudyLanguageFlags,
  caseStudyLanguageLabels,
} from '../../data/caseStudies';

const CaseStudyLanguageLabel = ({ locale }) => {
  const flag = caseStudyLanguageFlags[locale];

  return (
    <>
      {flag && (
        <img
          src={flag.src}
          alt=""
          aria-hidden="true"
          className="case-study-language-flag"
        />
      )}
      <span className="case-study-language-label">
        {caseStudyLanguageLabels[locale]}
      </span>
    </>
  );
};

export default CaseStudyLanguageLabel;
